import { Component, OnInit, ChangeDetectionStrategy, Input, OnDestroy, ChangeDetectorRef, ElementRef, AfterViewInit, HostBinding } from '@angular/core';
import { FormControl, ValidationErrors } from '@angular/forms';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { CheckBoxOptions } from '../checkbox/checkbox.component';
import { Abstract_Form_Component } from '../form-component.types';
import { ScrollService } from '../step/scroll.service';

@Component({
  selector: 'div[data-component-type=checkbox-group]',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckboxGroupComponent extends Abstract_Form_Component implements OnInit, AfterViewInit, OnDestroy {

  @HostBinding('class.error') touchedOrDirtyAndInvalid: boolean = false
  
  updateLabelState(): void { }

  @Input() checkboxes!: Omit<CheckBoxOptions, 'checked'>[]

  private destroy$: Subject<any> = new Subject()

  constructor(scroll: ScrollService, cd: ChangeDetectorRef, private el: ElementRef<HTMLElement>) {
    super(cd, scroll)
  }

  ngOnInit(): void {
    this.formControl.statusChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.error = this.formControl.invalid ? Object.keys(this.formControl.errors as ValidationErrors)[0] : null
      this.touchedOrDirtyAndInvalid = this.touchedOrDirty && this.formControl.invalid
    })
    this.scroll.notice$.pipe(
      takeUntil(this.destroy$)
    ).subscribe(path => {
      if (this.formControl.invalid) {
        this.touchedOrDirty = true
        this.touchedOrDirtyAndInvalid = true
      }
      if (path === this.path) this.el.nativeElement.scrollIntoView()
      this.cd.markForCheck()
    })
    this.error = this.formControl.invalid ? Object.keys(this.formControl.errors as ValidationErrors)[0] : null
  }

  ngAfterViewInit(): void {
    this.scroll.onInit$.pipe(
      first()
    ).subscribe(path => {
      if (path === this.path) this.el.nativeElement.scrollIntoView()
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next('')
    this.destroy$.complete()
  }

  onValueChange(value: { checked: boolean, value: string }) {
    let _value: any[] | null = Array.isArray(this.formControl.value) ? [...this.formControl.value] : []
    value.checked ? _value.push(value.value) : _value = _value.filter(item => item !== value.value)
    this.formControl.setValue(_value)
  }

  trackByFn(index: number, item: CheckBoxOptions) {
    return item.id
  }

}

export interface CheckboxGroupOptions {
  id: string,
  type: 'checkbox-group-component',
  formControl: FormControl,
  presence: boolean,
  checkboxes: CheckBoxOptions[],
  path: string,
  disabled: boolean
}